<template>
<transition name="fade">
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content">
      <button class="button-close-modal" @click="$emit('close')">X</button>
      <slot></slot>
    </div>
  </div>
</transition>
</template>

<script>
export default {
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, hsl(210, 30%, 20%, 0.7), hsl(255, 30%, 15%, 0.7)); 
    display: flex;
    opacity: 20;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    padding: 60px;
    background: var(--box-section-bgcolor);
    color: #333 !important;
    max-width: 1500px;
    border-radius: 10px;
    box-shadow: -1.6rem 2.4rem 20.2rem 0.2rem hsl(128.57deg 15.26% 9.65%);
    position: relative;
}

.modal-content h2 {
    font-size: 24px;
    color: #ecf0f1;
    margin-bottom: 10px;
}

/* Estilo do conteúdo/texto */
.modal-content p {
    font-size: 16px;
    color: #bdc3c7;
    margin-bottom: 20px;
}

.modal-content template {
    width: 100%;
}

/* Isso impede que o clique na modal feche-a */
.modal-content click.stop {
    pointer-events: none;
}

.button-close-modal {
    background-color: transparent;
    border: none;
    font-size: 24px;
    color: var(--text-color);
    position: absolute; 
    top: 20px;
    right: 20px;
    cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.05s;
}
.fade-enter, .fade-leave-to {
    opacity: 0.1;
}</style>
